const surnameAction = (state = "", action) => {
    switch(action.type) {
        case 'surnameAction':
            return action.payload;
        default:
            return state;
    }
}

export default surnameAction;